import * as React from "react"
import SettingsOverviewCard from "../../molecules/SettingsOverviewCard"
import TxIcon24x24 from "../../atoms/icons/TxIcon24x24"
import ButtonRow from "../../molecules/card/ButtonRow"
import ReadOnlyTextField from "../../molecules/card/ReadOnlyTextField"
import ToggleButton from "../../atoms/inputs/ToggleButton"
import TurnOffTxModal from "../modals/TurnTxOffModal"
import TurnOnTxModal from "../modals/TurnTxOnModal"
import { SECTION_OVERVIEW_TRANSMISSION } from "../../../utils/pages"
import { useEdgeApi } from "../../../edge/EdgeProvider"

interface Props {
  active: boolean
  onToggle: (active: boolean) => void
  onApply: () => void
}

const displayBool = (value: boolean | undefined): string | undefined =>
  value !== undefined ? (value ? "Yes" : "No") : undefined

const TransmissionCard: React.FunctionComponent<Props> = ({ active, onToggle, onApply }) => {
  const { metrics } = useEdgeApi()
  const [txOffModalOpen, setTxOffModalOpen] = React.useState<boolean>(false)
  const [txOnModalOpen, setTxOnModalOpen] = React.useState<boolean>(false)
  const [pendingApply, setPendingApply] = React.useState<boolean>(false)

  React.useEffect(() => {
    if (pendingApply) {
      onApply()
      setPendingApply(false)
    }
  }, [pendingApply, active])

  const handleToggleTransmission = () => {
    if (active) {
      setTxOffModalOpen(true)
    } else {
      setTxOnModalOpen(true)
    }
  }

  const handleConfirmTransmissionOff = () => {
    onToggle(false)
    setTxOffModalOpen(false)
    setPendingApply(true)
  }

  const handleConfirmTransmissionOn = () => {
    onToggle(true)
    setTxOnModalOpen(false)
    setPendingApply(true)
  }

  return (
    <>
      <SettingsOverviewCard title={SECTION_OVERVIEW_TRANSMISSION.name} icon={<TxIcon24x24 />}>
        <ButtonRow label="Transmission" button={<ToggleButton active={active} onToggle={handleToggleTransmission} />} />
        <ReadOnlyTextField placeholder="-.-" label="BUC Muted" value={displayBool(metrics.useBucInfoMuted())} />
        <ReadOnlyTextField
          placeholder="-.-"
          label="BUC Hard Muted"
          value={displayBool(metrics.useBucInfoHardMuted())}
        />
        <ReadOnlyTextField placeholder="-.-" label="LNB Muted" value={displayBool(metrics.useLnbInfoMuted())} />
      </SettingsOverviewCard>
      {txOffModalOpen && (
        <TurnOffTxModal
          open={txOffModalOpen}
          onClose={() => setTxOffModalOpen(false)}
          onConfirm={handleConfirmTransmissionOff}
        />
      )}
      {txOnModalOpen && (
        <TurnOnTxModal
          open={txOnModalOpen}
          onClose={() => setTxOnModalOpen(false)}
          onConfirm={handleConfirmTransmissionOn}
        />
      )}
    </>
  )
}

export default TransmissionCard
